import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { CountryModel } from 'src/app/masters/country/country.model';
import { MasterService } from 'src/app/masters/master.service';
import { OrganismModel } from '../organisms/organism.model';
import * as CommonConstants from '../../utils/common.constants';
import { TelemedicineService } from './telemedicine.service';
import { FormGroup, FormBuilder, FormControl } from '@angular/forms';
import { AddTelemedicineComponent } from './add-telemedicine/add-telemedicine.component';
import { PartnerSearchComponent } from '../partner-search/partner-search.component';
import { LoaderService } from 'src/app/common/loader.service';
import { SharedService } from 'src/app/utils/shared.service';

@Component({
  selector: 'app-telemedicines',
  templateUrl: './telemedicines.component.html',
  styleUrls: ['./telemedicines.component.scss']
})
export class TelemedicinesComponent implements OnInit {

  organisms: OrganismModel[];
  countries: CountryModel[];
  towns: any[];
  columnDefs: any[];
  addTelemedicine;
  startIndex;
  rowsPerPage;
  totalRecords;
  teleMedicineSearchForm: FormGroup;
  rowData: any[];
  toggleColumn = true;
  @ViewChild(PartnerSearchComponent,{static:true})   pSearch : PartnerSearchComponent;
  addressTypeList : any[];
  
  newTelemedicine: AddTelemedicineComponent;
  priv_addTele: any;
  @ViewChild(AddTelemedicineComponent, { static: true }) set Content(newTelemedicineRef) {
    this.newTelemedicine = newTelemedicineRef;
  }
  constructor(public router: Router, private teleService: TelemedicineService, private formBuilder: FormBuilder,
    private masterService: MasterService, private loaderService: LoaderService,private sharedService:SharedService) {

    this.columnDefs = [
      // { headerName: 'Id', field: 'telemId', width: 75 },
      { headerName: 'Name', field: 'compaVaName'},
      { headerName: 'Organism', field: 'orgName'},
      { headerName: 'Work Phone', field: 'compaVaWorkPhone'},
      { headerName: 'Mobile Phone', field: 'compaVaMobilePhone1'},
      { headerName: 'Email', field: 'compaVaEmail1'}
    ];

  }

  ngOnInit() {
    this.priv_addTele=this.sharedService.hasPrivilege(CommonConstants.PRIV_ADD_TELEMEDICINE);
    this.pSearch.pSearch["active"]=true;
    this.pSearch.partnerType=CommonConstants.PARTNER_TELEMEDICINE_TYPE;
    this.loadMasterData();
    this.getFormGroup();
    this.search();
  }

  /**
   * Declare form group
   *  
   */
  private getFormGroup() {
    this.teleMedicineSearchForm = this.formBuilder.group({
      'orgsmId': new FormControl(),
      'compaVaName': new FormControl(),
      'cotryId': new FormControl(),
      'townId': new FormControl()

    })
  }

  loadMasterData() {
    this.masterService.getTown().subscribe(response => {
      if (response['code'] == 'S0000') {
        this.towns = response['result'];
      }
    });

    this.masterService.getCountry().subscribe(response => {
      if (response['code'] == 'S0000') {
        this.countries = response['result'];
      }
    });
    this.masterService.getOrganisms().subscribe(response => {
      if (response && response['result']) {
        this.organisms = response['result'];
      }
    })
    this.masterService.getAddressTypes().subscribe(response => {
      if (response['code'] == 'S0000') {
        this.addressTypeList = response['result'];
      }
    });
  }

  addNewTelemedicine() {
    this.router.navigate(['addTelemedicine']);
    this.newTelemedicine.addTelemedicineTitle = true;
    this.newTelemedicine.editTelemedicineTitle = false;
  }

  hideRightDiv() {
    this.addTelemedicine = false;
    this.toggleColumn = true;
  }

  search() {
    this.startIndex = 0;
    this.rowsPerPage = CommonConstants.PAGINATION_SIZE;
    this.paginatedList();
    this.hideRightDiv();
    /* this.hospitalService.searchHospitals(this.hospitalSearch).subscribe(response => {
      console.log(response['result']);
      this.rowData = response['result'];
    }) */
  }
  paginatedList() {
    this.loaderService.display(true);
    this.pSearch.pSearch['partnerType'] = 5;
    this.pSearch.pSearch['active']=this.pSearch.pSearch['active'] ? 'A' :'I';
    this.teleService.searchTeleMedicines(this.pSearch.pSearch, this.startIndex).subscribe(response => {
      this.loaderService.display(false);
      let result = response['result'];
      if (result) {
        result= result.map(item => ({
          ...item,
          orgName: item.orgsmId ? this.organisms.find(obj => obj.orgsmId === item.orgsmId).compaVaNameEn : null
        }))
      }
      this.rowData = result;
      this.totalRecords = result.length;
    },
    error => {
      this.loaderService.display(false);
    })
  }

  paginate(event: any) {
    this.startIndex = event.first;
    this.rowsPerPage = event.rows;
    this.paginatedList();
  }

  onRowClicked(event: any) {
    this.addTelemedicine = true;
    this.toggleColumn = false;
    this.newTelemedicine.addTelemedicineTitle = false;
    this.newTelemedicine.editTelemedicineTitle = true;
    this.loadTelemedicineById(event);
  }


  loadTelemedicineById(event: any) {
    this.loaderService.display(true);
    this.teleService.getTelemedicineById(event.data.telemId).subscribe(response => {
      this.loaderService.display(false);
      this.newTelemedicine.hospDepartment.departmentList = [];
      this.newTelemedicine.hospAddress.addressList = [];
      if (response['code'] == 'S0000') {
        let result = response['result'][0];
        this.newTelemedicine.teleMedicineForm.patchValue({
          telemId: result["telemId"],
          compaNuNumberEmployees: result["compaNuNumberEmployees"],
          compaVaEmail1: result["compaVaEmail1"],
          compaVaMobilePhone1: result["compaVaMobilePhone1"],
          compaVaWorkPhone: result["compaVaWorkPhone"],
          compaVaMobilePhone2: result["compaVaMobilePhone2"],
          compaVaNameEn: result["compaVaNameEn"],
          compaVaWorkFax: result["compaVaWorkFax"],
          leforId: result["leforId"],
          orgsmId: result["orgsmId"],
          pacatId: result["pacatId"],
          pctypId: result["pctypId"],
          pagrpId: result["pagrpId"],
          compaVaHomepage: result["compaVaHomepage"],
          qcertiId: result["qcertiId"],
          certiId: result["certiId"],
          staRecCode: result["staRecCode"] ==='A' ? true : false

        });

        result['addressList'] = result.addressList.map(item => ({
          ...item,
          addressType: item.typeId ? this.addressTypeList.find(obj => +obj.typeId === +item.typeId).description : null,
          townName: item.townId ? this.towns.find(town => town.townId === item.townId).townDescEn : null,
          countryName: item.cotryId ? this.countries.find(country => country.cotryId === item.cotryId).cotryDescEn : null
        }));
        this.newTelemedicine.hospDepartment.departmentList = JSON.parse(JSON.stringify(result['departmentList']));
        this.sharedService.setOrganismDepartment(this.newTelemedicine.hospDepartment.departmentList);
        this.newTelemedicine.hospAddress.addressList = JSON.parse(JSON.stringify(result['addressList']));
        this.newTelemedicine.phoneNos.forEach(phone => {
          phone.phone=phone.getInternationPhoneFormat(result[phone.type]);
      })
      }
    },
    error => {
      this.loaderService.display(false);
    })
  }
  reset() {
    this.teleMedicineSearchForm.reset();
    this.rowData =[];
    this.pSearch.pSearch={};
    this.hideRightDiv();
  }

}
